export default {
  text: {
    en: 'PLEASE DO NOT CLOSE OR REFRESH THE PAGE UNTIL PAYMENT HAS PROCESSED',
  },
}
